import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import typography from './typography';
import palette from './palette';
import components from './components';

const overridesTheme = createTheme({ typography, palette, components });
export const mainTheme = responsiveFontSizes(overridesTheme);
